import { useParams } from '@fs/zion-router'
import Cache from '@fs/zion-cache'
import { mutate } from 'swr'
import axios from '@fs/zion-axios'
import type { FamilyMembers, PersonId } from '@fs/zion-tree-types'
import { useGroupsContext } from '@fs/zion-tree-groups'
import type { SwrResponse } from './useSwrRequest'
import { updateRequest, useSwrRequest } from './useSwrRequest'
import { mutateChangeLogSummary } from './useChangeLogSummary'

const familyMembersCache = new Cache({
  storeName: 'familyMembers_r9',
  encrypted: process.env.NODE_ENV === 'production',
})

export const swrKey = (pid: string, treeId: string): string =>
  pid ? `/service/tree/tree-data/r9/family-members/person/${pid}?includePhotos=true&treeId=${treeId}` : ''

export default function useFocusFamilyMembers(): SwrResponse<FamilyMembers> & {
  focusFamilyMembers: FamilyMembers
} {
  const { currentTreeId } = useGroupsContext()
  const { pid } = useParams()
  const cache = familyMembersCache
  const response = useSwrRequest<FamilyMembers>(swrKey(pid, currentTreeId || 'PRIVATE'), cache)

  return {
    ...response,
    focusFamilyMembers: response.data ?? { spouses: [], parents: [] },
  }
}

export async function addCoupleRelationship(
  parent1Id: PersonId,
  parent2Id: PersonId,
  focusPersonId: PersonId,
  treeId: string
): Promise<void> {
  const url = `/service/tree/tree-data/person/${parent1Id}/relationships/spouses`
  const payload = {
    excludeUnknownChildren: true,
    spouseId: parent2Id,
    spouseInPositionOne: false,
  }

  await updateRequest(swrKey(focusPersonId, treeId), undefined, () => axios.post(url, payload))
}

export function mutateFocusFamilyMembers(pid: PersonId, treeId: string): void {
  mutate(swrKey(pid, treeId))
  mutateChangeLogSummary(pid, treeId)
}
